var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin"},[_c('reset-new-password-form',{attrs:{"submit":_vm.createPassword,"cancel":_vm.cancelCreatePassword,"sendAgain":_vm.goToResetPassword,"email":_vm.email,"code":_vm.code}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }